import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { useGetParams } from '@hooks/envelopes/useGetParams';
import { closeLoader, showLoader } from '@store/modules/loader';
import { getEnvelope, getEnvelopes, resetCurrentBoxOguid, setEnvelopeReadState } from '@store/modules/envelopes';
import { catchThunkError } from '@utils/utils';
import TasksService from '@services/tasks';

export const useLoadEnvelopes = () => {
  const dispatch = useAppDispatch()
  const { profile } = useAppSelector(state => state.user)

  const {
    direction,
    boxOguid,
    folder,
    page,
    perPage,
    oguid,
    otherSearchParams
  } = useGetParams()

  const loadEnvelopes = useCallback((): void => {
    if (folder) return

    dispatch(showLoader())

    dispatch(getEnvelopes({ direction, boxOguid, page, perPage, otherSearchParams })).unwrap()
      .catch(err => {
        catchThunkError(err);
        dispatch(resetCurrentBoxOguid());
      })
      .finally(() => dispatch(closeLoader()))
  }, [boxOguid, direction, dispatch, folder, otherSearchParams, page, perPage])

  const loadCurrentEnvelope = useCallback(() => {
    const envelopeBoxOguid = boxOguid ?? profile.boxOguid

    if (!oguid || !envelopeBoxOguid) return

    dispatch(showLoader())
    dispatch(getEnvelope({ direction, oguid, boxOguid: envelopeBoxOguid })).unwrap()
      .then((envelope) => {
        if (!envelope || envelope.isRead || !envelope.currentUserTaskOguid) return

        TasksService.postTasksMarkIsRead([envelope.currentUserTaskOguid], true)
          .then(() => {
            dispatch(setEnvelopeReadState({
              boxOguid: envelope.box.oguid,
              envelopeOguid: envelope.oguid,
              isRead: true,
            }))
          })
          .catch(catchThunkError)
      })
      .catch(catchThunkError)
      .finally(() => dispatch(closeLoader()))
  }, [boxOguid, direction, dispatch, oguid, profile.boxOguid])

  return { loadEnvelopes, loadCurrentEnvelope }
}
